var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaseScenario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 97,
    height: 97,
    rx: 8.5,
    fill: "white",
    stroke: "#339999",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1667 52.1667H50.1908",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8333 37.6667V32.8333C59.8333 31.5515 59.3241 30.3221 58.4177 29.4157C57.5113 28.5092 56.2819 28 55 28H45.3333C44.0515 28 42.8221 28.5092 41.9157 29.4157C41.0092 30.3221 40.5 31.5515 40.5 32.8333V37.6667",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3333 54.5835C67.1626 59.3177 58.7592 61.8415 50.1667 61.8415C41.5741 61.8415 33.1708 59.3177 26 54.5835",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 37.6667H30.8333C28.164 37.6667 26 39.8307 26 42.5001V66.6667C26 69.3361 28.164 71.5001 30.8333 71.5001H69.5C72.1694 71.5001 74.3333 69.3361 74.3333 66.6667V42.5001C74.3333 39.8307 72.1694 37.6667 69.5 37.6667Z",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseScenario);
export default __webpack_public_path__ + "static/media/CaseScenario.747ea3da487e32c7d76ff61822da63f2.svg";
export { ForwardRef as ReactComponent };